import { render, staticRenderFns } from "./HypotekaItemDetail.vue?vue&type=template&id=0dd175fa&scoped=true&"
import script from "./HypotekaItemDetail.vue?vue&type=script&lang=js&"
export * from "./HypotekaItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd175fa",
  null
  
)

export default component.exports